import { render, staticRenderFns } from "./spot_space_purchase.vue?vue&type=template&id=5427df13&scoped=true&"
import script from "./spot_space_purchase.vue?vue&type=script&lang=js&"
export * from "./spot_space_purchase.vue?vue&type=script&lang=js&"
import style0 from "./spot_space_purchase.vue?vue&type=style&index=0&id=5427df13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427df13",
  null
  
)

export default component.exports